
import axios from 'axios';
import { LLMMRPCResponse } from '../../types/llm';

export const getMRPCResults = async (
  sentence1: string,
  sentence2: string
) => {
  return await axios
    .post<LLMMRPCResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/mrpc`,
      {
        sentence1: sentence1,
        sentence2: sentence2,
      }
    )
    .then((response) => {
      return response.data;
    });
};
